module.exports = __webpack_public_path__ + "img/log-in.6c3aec23.svg";